/**
 * Usage display configuration driven by VITE_USAGE_CONFIG env variable.
 *
 * Possible values:
 *  - TOKEN_ONLY         → show token stats, hide duration
 *  - DURATION_ONLY      → show duration, hide token stats; costs are
 *                         hidden for regular users but visible to admins
 *  - TOKEN_AND_DURATION → show both (default)
 */

export type UsageConfigMode = 'TOKEN_ONLY' | 'DURATION_ONLY' | 'TOKEN_AND_DURATION';

const getUsageConfig = (): UsageConfigMode => {
  const raw = (import.meta.env.VITE_USAGE_CONFIG ?? '').toString().trim().toUpperCase();
  if (raw === 'TOKEN_ONLY' || raw === 'DURATION_ONLY') return raw;
  return 'TOKEN_AND_DURATION';
};

export const USAGE_CONFIG = getUsageConfig();

export const showTokens = USAGE_CONFIG !== 'DURATION_ONLY';
export const showDuration = USAGE_CONFIG !== 'TOKEN_ONLY';

export const canShowCost = (isAdmin: boolean): boolean =>
  USAGE_CONFIG !== 'DURATION_ONLY' || isAdmin;
